import React from "react";
import Modal from "react-responsive-modal";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NumberField, RadioField } from "Utils/renderField/fieldsHookForms";
import {
    FLETE_EXTERNO_COSTO_FIJO,
    FLETE_EXTERNO_COSTO_POR_KG,
} from "../../../../../utility/constants";
import { useFleteExternoForm } from "./hooks/useFleteExternoForm";

const PrecioFlete = (props) => {
    const { titulo, campoTipo, campoCosto, formHook } = props;
    const tipoSeleccionado = formHook.watch(campoTipo);

    return (
        <CardEmpty noShadow>
            <label>{titulo}</label>
            <div className="d-flex gap-1rem mb-2">
                <RadioField
                    name={campoTipo}
                    label="POR KG."
                    value={FLETE_EXTERNO_COSTO_POR_KG}
                    checked={tipoSeleccionado === FLETE_EXTERNO_COSTO_POR_KG}
                    onChange={() =>
                        formHook.setValue(campoTipo, FLETE_EXTERNO_COSTO_POR_KG)
                    }
                />
                <RadioField
                    name={campoTipo}
                    label="POR FLETE"
                    value={FLETE_EXTERNO_COSTO_FIJO}
                    checked={tipoSeleccionado === FLETE_EXTERNO_COSTO_FIJO}
                    onChange={() =>
                        formHook.setValue(campoTipo, FLETE_EXTERNO_COSTO_FIJO)
                    }
                />
            </div>
            <NumberField
                control={formHook.control}
                name={campoCosto}
                errors={formHook.errors}
                prefix="Q "
                decimalScale={2}
                allowNegative={false}
                rules={{
                    min: {
                        value: 0,
                        message: "El precio no puede ser negativo",
                    },
                }}
            />
            {/* El card quedó con paddings desiguales, por eso se agrega esto para mejorar aspecto */}
            <div className="pt-3" />
        </CardEmpty>
    );
};

export const ModalFleteExterno = (props) => {
    const { finca, onClose, onGuardado } = props;
    const formHook = useFleteExternoForm(finca, onGuardado);

    return (
        <Modal
            open={!!finca}
            onClose={onClose}
            closeOnOverlayClick={false}
            focusTrapped={false}
            styles={{
                modal: {
                    maxWidth: "700px",
                    width: "100%",
                },
            }}
        >
            <h4 className="text-center mb-1">
                PRECIO DE FLETE AJENO AL PRODUCTOR
            </h4>
            <p className="text-center mb-4">{finca ? finca.nombre : ""}</p>

            <div className="row col-12 m-0 p-0">
                <div className="col-md-6 col-12 mb-3 px-md-2 px-0">
                    <PrecioFlete
                        titulo="LÁTEX"
                        campoTipo="tipo_costo_flete_externo_latex"
                        campoCosto="costo_flete_externo_latex"
                        formHook={formHook}
                    />
                </div>
                <div className="col-md-6 col-12 mb-3 px-md-2 px-0">
                    <PrecioFlete
                        titulo="SÓLIDO"
                        campoTipo="tipo_costo_flete_externo_solido"
                        campoCosto="costo_flete_externo_solido"
                        formHook={formHook}
                    />
                </div>
            </div>

            <small className="d-block text-center mb-3">
                Un precio en 0 indica que la finca no tiene precio de flete
                ajeno configurado.
            </small>

            <div className="d-flex flex-wrap justify-content-center mt-2 mb-2 gap-1rem">
                <button
                    className="btn btn-outline-dark"
                    onClick={onClose}
                    disabled={formHook.cargando}
                >
                    CANCELAR
                </button>
                <button
                    className="btn btn-primary"
                    onClick={formHook.guardar}
                    disabled={formHook.cargando}
                >
                    GUARDAR
                </button>
            </div>
        </Modal>
    );
};

export default ModalFleteExterno;
